export const isPremiumPlan = (plan: string) => {
    return plan?.toLowerCase().includes("premium");
};
